let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("68Kzv"), load("3NvtU"), load("7FkEF"), load("kuj0P")]).then(() => parcelRequire('6gB2z'));